<template>
	<div>
		<div class="inner_banner">
			<img src="~@/assets/image/probanner.jpg" />
			<div class="container bannertxt">
				<div>
					<div class="banner_title" style="color: #333333 !important">产品中心</div>
					<div class="banner_sub_title" style="color: #333333 !important">展特易/产品中心</div>
				</div>
			</div>

		</div>
		<div class="zqrow">
			<div class="content container">
				<div class="zq_left">

					<ul class="cate_ul">
						<div class="title">所有服务</div>
						<li class="hasbord" v-for="(item,i) in allcatList" v-bind:class={active:item.active?item.active:false}>
							<div class="cate_name"
								v-bind:class={active:item.active,has_son:item.child.length?item.child.length:0}
								@click="open_nav(i)">{{item.name}}</div>

							<ul class="son" v-for="it in item.child">
								<el-collapse-transition>
									<li @click="selectCat(it.id)" class="transition-box" v-show="!item.active">
										<div class="cate_name">{{it.name}}</div>
									</li>
								</el-collapse-transition>
							</ul>

						</li>



						<!-- <div class="spilt_bj"></div>
						<div class="title_choose">筛选</div>
						<div class="tag_list">
							<div class="tag" @click="selectParams('all')"><img
									src="~@/assets/image/chooseclose.svg" />清除所有标签</div>
						</div>
						<div class="choose_group">
							<div class="choose_item" v-for="param in allParameters">
								<div class="choose_item_name">{{param.name}}</div>
								<ul class="choose_list">
									<li v-for="(item,i) in param.value" @click="selectParams(item)">
										<div class="choose_btn" v-bind:class={on:isparam(item)}>
											<img src="~@/assets/image/k.svg" />
										</div>
										<div class="choose_item_li_name">{{item}}</div>
										<div class="choose_num"></div>
									</li>
								</ul>
							</div>
						</div> -->
					</ul>
				</div>
				<div class="zq_right">
<!--					<div class="first_product_card">-->
<!--						<div class="zq_left">-->
<!--							<div class="cate_card">-->
<!--								<img v-bind:src="banner" />-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="zq_right">-->
<!--							<div class="des">-->
<!--								<div class="title">{{curcatename}}</div>-->
<!--								<div class="inner_des">{{readme}}</div>-->
<!--							</div>-->

<!--						</div>-->
<!--					</div>-->
					<div class="search-tip">
						<div class="search_word">搜索到{{totalPro}}个相关产品</div>
						<div>

						</div>
					</div>
					<!-- <div class="sreach_res">
						<div class="text">筛选标签</div>
						<div class="search_list">
							<div class="search_res_tag" v-for="(item,i) in paramsList" v-if="isparam(item)"
								@click="selectParams(item)">{{item}}</div>
						</div>
					</div> -->
					<div class="product_list" v-loading="loadingShow">

						<div class="product_item" v-for="(good) in goodsList" :key="good.id">
							<router-link :to="{name:'detail',params: {goodsId:good.id}}">
								<div class="product_item_img">
								<img v-bind:src="good.image_url" />
								</div>
								<div>
									<div class="title">{{good.name}}</div>
									<div class="price">￥{{good.price}}</div>
                  <div class="">
                    <div class="flex product_order_group innerpage">
                      <div class="shipping_btn">加入购物车</div>
                      <div class="shipping_icon"><img src="~@/assets/image/shippingicon.png"> </div>
                    </div>
                  </div>
								</div>
							</router-link>
						</div>




					</div>
				</div>
			</div>
		</div>

		<template v-if="goodsList.length>0">
			<Pagination :totalPage="totalPage" :limit="searchOptions.limit" @changePage="handleCurrentChange">
			</Pagination>
		</template>

	</div>
</template>
<script>
	import Pagination from "@/components/common/Pagination.vue";
	import {
		deepCopy
	} from "@/utils";
	import {
		goodsStyle
	} from "@/utils";
	import {
		forEach
	} from "core-js/fn/dict";
	import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
	export default {
		name: "SearchResult",
		components: {
			Pagination
		},
		props: {},
		data() {
			return {
				loadingShow: false,
				totalPage: 0,
				goodsList: [],
				showFilter: true,
				firstLoad: true, //是否初次加载
				catList: [], //分类
				allcatList: [], //所有分类,
				brandList: [], //品牌
				labelList: [], //筛选标签	
				paramsList: [],
				noDataIsShow: false,
				loadingShow: false,
				banner: require("@/assets/image/first_pro.png"),
				readme: "所有产品描述",
				curcatename: "所有产品",
				allParameters: [],
				isopen: false,
				searchOptions: {
					where: {},
					limit: 15,
					page: 1,
					order: {
						key: "sort",
						sort: "asc" //默认综合排序
					}
				},
				totalPro: 0,
			};

		},
		watch: {},
		computed: {

		},
		methods: {
			open_nav: function(k) {
				//this.allcatList[k].active = !this.allcatList[k].active;
				//console.log("this.allcatList[k].active",k);
				this.$set(this.allcatList[k], 'active', !this.allcatList[k].active)
				//console.log("this.allcatList[k].active",this.allcatList[k].active);
			},
			isparam(id) {
				let index = this.paramsList.indexOf(id);
				console.log("index",index);
				if (index > -1) {
					return true;
				} else {
					return false;
				}
			},			
			//获取分类
			categories() {
				this.$api.categories().then(res => {
					if (res.status) {
						this.allcatList = res.data;
						console.log("allcatList", this.allcatList);
					}
				});
			},
			//搜索分类
			selectCat(id) {
				let data = {
					page: 1,
					where: {
						cat_id: id
					}
				};
				console.log("data", data);
				this.selectedCatId = id;
				this.setSearchOptions(data, true);
				this.getGoodsList();
				this.setCateBanner(id);
			},
			//搜索品牌
			selectParams(id) {
				if (id == "all") {
					this.paramsList = [];
				} else {
					let index = this.paramsList.indexOf(id);
					console.log("indexindex",index);
					if (index > -1) {
						this.paramsList.splice(index, 1);
						delete this.searchOptions.where.params;
					} else {
						this.paramsList.push(id);
					}
				}
				
				
				
				let	 data = {
						page: 1,
						where: {
							params: this.paramsList
						}
					};

			console.log("this.paramsListdata",data);
				this.setSearchOptions(data, true);
				this.getGoodsList();
			},
			setCateBanner(selectedCatId) {
				let that = this;
				this.allcatList.forEach(function(cate, i) {

					cate.child.forEach(function(child, j) {
						if (child.id == selectedCatId) {
							that.banner = child.image_url ? child.image_url : "";
							that.curcatename = child.name ? child.name : "";
							that.readme = child.readme ? child.readme : "";
						}
					})
				})
			},
			// categoriesTypeval() {
			// 	let obj = {
			// 		id: 4
			// 	};
			// 	this.$api.categoriesTypeval(obj).then(res => {
			// 		if (res.status) {
			// 			this.categoriesTypeval = res.data;
			// 			console.log("categoriesTypeval", this.categoriesTypeval);
			// 		}
			// 	});
			// },

			//设置筛选条件
			setSearchOptions: function(searchData, clear = false) {
				var sd = this.searchOptions;
				this.searchOptions = deepCopy(sd, searchData);
				if (clear) {
					this.goodsList = [];
				}
			},
			//分页
			handleCurrentChange(val) {
				console.log("val", val);
				this.setSearchOptions({
					page: val
				});
				this.getGoodsList();
			},
			handleParamsData(query) {
				console.log("handleParamsData");
				let where = {};
				if (query.key) {
					where = {
						search_name: query.key
					};
				}
				if (query.id) {
					where = {
						cat_id: query.id
					};
				}
				if (query.type) {
					if (query.type == "hot") {
						where = {
							hot: true
						};
					}
					if (query.type == "recommend") {
						where = {
							recommend: true
						};
					}
				}
				this.setSearchOptions({
					where: where
				});
				this.getGoodsList();
				this.categories();
				// this.categoriesTypeval();
				this.getAllParameters();
			},
			getAllParameters() {
				this.$api.getAllParameters().then(res => {
					if (res.status) {
						this.allParameters = res.data;
					}
				})
			},
			//获取商品列表
			getGoodsList() {
				console.log("获取商品列表");
				let obj = this.conditions();
				console.log("obj", obj);
				this.loadingShow = true;
				this.$api.goodsList(obj).then(res => {
					console.log("res", res);
					if (res.status) {
						this.totalPage = res.data.total_page;
						this.totalPro = (res.data.page - 1) * res.data.limit + res.data.list.length
						this.goodsList = res.data.list;
						this.showFilter = this.goodsList.length > 0 ? true : false;
						let filter = res.data.filter;
						if (this.firstLoad) {
							this.firstLoad = false;
							this.catList = filter.goods_cat ? filter.goods_cat : [];
							this.brandList = filter.brand_ids ? filter.brand_ids : [];
							this.labelList = filter.label_ids ? filter.label_ids : [];
						}
						if (res.data.list.length == 0) {
							this.noDataIsShow = true;
						} else {
							this.noDataIsShow = false;
						}
						this.loadingShow = false;
					}
				});
			},
			//筛选条件参数处理
			conditions() {
				let data = this.searchOptions;
				var newData = {};
				newData = deepCopy(newData, data);
				//把data里的where换成json
				if (data.where) {
					newData.where = JSON.stringify(data.where);
				}
				//把排序换成字符串
				if (data.order) {
					var sort = data.order.key + " " + data.order.sort;
					if (data.order.key != "sort") {
						sort = sort + ",sort asc"; //如果不是综合排序，增加上第二个排序优先级排序
					}
					newData.order = sort;
				} else {
					newData.order = "sort asc";
				}
				return newData;
			},

			tag_click: function(k) {
				if (k == "all") {
					let that = this
					this.tag_list.forEach(function(v, i) {
						that.tag_list[i].active = 0;
					})
				} else {
					this.tag_list[k].active = !this.tag_list[k].active;
				}

			}
		},
		created() {
			let query = this.$route.query;
			console.log("query", query);
			this.handleParamsData(query);
			this.goodsStyle = goodsStyle;
		},
		mounted() {

			this.$nextTick(function() {
				let galleryTop = new Swiper('.ad_row_right', {
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					spaceBetween: 80,
					slidesPerView: "auto",
					loop: true,
					pagination: '.swiper-pagination',
					paginationType: 'custom',
					paginationCustomRender: function(swiper, current, total) {
						return "<div class='custompagination'><div class='cur'>" + current + "</div>" +
							'<div class="pagination_txt">/</div>' + '<div class="pagination_txt">' +
							total + '</div></div>';
					}
				});

			})
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/product.scss";

	.inner_banner > img{
		width: 100%;
	}
</style>
